import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormSelect } from '@getro/rombo';

const LayoutSelector = ({ value, onChange, onDropDownStateChange, currentListView }) => {
  const options = [
    { label: 'Table', value: 'table_view' },
    { label: 'Cards', value: 'cards_view' },
  ];

  const getInitialValue = () => {
    if (value) {
      return options.find((option) => option.value === value);
    }
    if (currentListView === 'card') {
      return options.find((option) => option.value === 'cards_view');
    }
    return options.find((option) => option.value === 'table_view');
  };

  const [localValue, setLocalValue] = useState(getInitialValue);

  useEffect(() => {
    if (value) {
      const newValue = options.find((option) => option.value === value);
      if (newValue) {
        setLocalValue(newValue);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const currentValue = localValue;

  return (
    <FormSelect
      label="Layout"
      options={options}
      size="medium"
      anchorToBody
      onMenuOpen={() => onDropDownStateChange('open')}
      onMenuClose={() => onDropDownStateChange('close')}
      field={{
        id: 'layout',
        name: 'layout',
        onChange: ({ target: { value: newValue } }) => {
          setLocalValue(newValue);
          onChange(newValue);
        },
        value: currentValue || options[0],
      }}
    />
  );
};

LayoutSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onDropDownStateChange: PropTypes.func.isRequired,
  currentListView: PropTypes.string,
};

LayoutSelector.defaultProps = {
  value: null,
  currentListView: 'table',
};

export default LayoutSelector;
